import { Card, Space } from 'antd';
import React from 'react';
import PageTitle from '../../common/PageTitle';
import { useTranslation } from 'react-i18next';
import getActions from '../actions/componentListActions';
import ComponentsList from '../components/componentsList';
import { useGetComponentListQuery } from '../../../features/courses/coursesApi';
import { useUserProfileQuery } from '../../../features/auth/authApi';

const ComponentsPage = () => {
    const { t } = useTranslation();
    const { data: user } = useUserProfileQuery('userDetails');
    const { data: components } = useGetComponentListQuery('course-components');

    const sortComponents = (components) => {
        if (!Array.isArray(components)) return [];
        const mutableComponents = [...components];
        return mutableComponents.sort((a, b) => {
            return (
                new Date(b.created_at).getTime() -
                new Date(a.created_at).getTime()
            );
        });
    };

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle
                title={t('workbench.lessons.dashboard.header') as String}
                actions={getActions(user)}
            />
            <Card
                style={{
                    backgroundColor: 'rgb(0,0,0,0)',
                    boxShadow: '0px 0px',
                }}
                bordered={false}
                bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}
            >
                <ComponentsList components={sortComponents(components)} />
            </Card>
        </Space>
    );
};

export default ComponentsPage;
